import _Fab from './fab';
import { withInstall } from '../shared';

import './style';

export const Fab = withInstall(_Fab);
export default Fab;
